


// // // // // // // import { useSelector } from "react-redux";
// // // // // // // import useAuthCalls from "../service/useAuthCalls";
// // // // // // import * as React from "react";
// // // // // // import Section1 from "../components/Section1";
// // // // // // import Footer from "../components/Footer";
// // // // // // import Testimonials from "../components/Testimonials";
// // // // // // import Stats from "../components/Stats";
// // // // // // import SearchBox from "../components/SearchBox";
// // // // // // import BlogPosts from "../components/BlogPosts";
// // // // // // import TransferOptionsMobile from "../components/TransferOptionsMobile";
// // // // // // import MobileTransferSearch from "../components/MobileTransferSearch";
// // // // // // import VipServices from "../components/VipServices";
// // // // // // import { useTranslation } from "react-i18next";
// // // // // // import DealCountdown from "../components/DealCountdown";

// // // // // // function Dashboard() {
// // // // // //   // const { user } = useSelector((state) => state.auth);
// // // // // //   // const { logout } = useAuthCalls();
// // // // // //   const { t } = useTranslation();

// // // // // //   return (
// // // // // //     <>
// // // // // //       <section className="relative w-full">
// // // // // //         {/* === PC Görseli ve Arama Kutusu === */}
// // // // // //         <div
// // // // // //           className="hidden md:block bg-cover bg-center bg-no-repeat"
// // // // // //           style={{
// // // // // //             // backgroundImage: "url('/images/pcbanner4.png')",
// // // // // //             backgroundImage: "url('/images/womanbanner.png')",
// // // // // //             height: "700px",
// // // // // //             width: "100%",
// // // // // //             // marginTop: "10px",
// // // // // //           }}
// // // // // //         >
// // // // // //           <div
// // // // // //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// // // // // //             style={{ marginTop: "80px" }}
// // // // // //           >
// // // // // //             <h1 className="text-4xl font-bold mb-6">{t("home.title")}</h1>
// // // // // //           </div>

// // // // // //           <div
// // // // // //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// // // // // //             style={{ marginTop: "650px" }}
// // // // // //           >
// // // // // //             <SearchBox />
// // // // // //           </div>
// // // // // //         </div>

// // // // // //         {/* === Mobil Görsel ve Arama Kutusu === */}
// // // // // //         <div className="block md:hidden relative">
// // // // // //           <img
// // // // // //             // src="/images/mobilebanner2.png"
// // // // // //             src="/images/mobile8.png"
// // // // // //             alt="Mobil VIP Transfer"
// // // // // //             className="w-full h-[680px] object-cover"
// // // // // //             style={{ marginTop: "-80px" }}
// // // // // //           />
// // // // // //           <div className="absolute inset-0 bg-black/30 flex flex-col justify-start pt-[330px] items-center text-white text-center px-4 gap-3">
// // // // // //             {/* Başlık kutusu */}
// // // // // //             <div className="bg-black/60 rounded px-4 py-1 backdrop-blur-sm">
// // // // // //               <h1 className="text-xl font-bold text-white">{t("home.title")}</h1>
// // // // // //             </div>

// // // // // //             {/* Transfer kutuları */}
          
// // // // // //  <div className="w-screen -mx-4 bg-black/95 ">
// // // // // //    <div className="max-w-md mx-auto px-4 py-5 mt-50 ">
// // // // // //    <DealCountdown />
// // // // // //    </div>
// // // // // //  </div>

 
// // // // // //             {/* Fiyat açıklaması */}
// // // // // //             {/* <p className="text-xs text-gray-300 mt-1 italic text-center">
// // // // // //               {t("home.note")}
// // // // // //             </p> */}
// // // // // //             {/* Fiyat açıklaması */}
// // // // // // {/* Fiyat açıklaması */}
// // // // // // <p className="text-[14px] md:text-[16px] font-semibold text-red-500 mt-0  text-center uppercase tracking-wide">
// // // // // //   {t("home.note")}
// // // // // // </p>



            
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </section>
  
    
// // // // // //       {/* Mobil transfer form bileşeni (siyah zemin) */}
// // // // // //      <div className="mt-40"> <MobileTransferSearch /></div>
// // // // // //       <TransferOptionsMobile />
// // // // // //       <div className="hidden md:block">
// // // // // //         <Section1 />
// // // // // //       </div>
// // // // // //       <VipServices />
// // // // // //       <Testimonials />
// // // // // //       <BlogPosts />
// // // // // //       <Stats />
// // // // // //       <Footer />
// // // // // //     </>
// // // // // //   );
// // // // // // }
// // // // // // export default Dashboard;

// // // // // // import { useSelector } from "react-redux";
// // // // // // import useAuthCalls from "../service/useAuthCalls";
// // // // // import * as React from "react";
// // // // // import Section1 from "../components/Section1";
// // // // // import Footer from "../components/Footer";
// // // // // import Testimonials from "../components/Testimonials";
// // // // // import Stats from "../components/Stats";
// // // // // import SearchBox from "../components/SearchBox";
// // // // // import BlogPosts from "../components/BlogPosts";
// // // // // import TransferOptionsMobile from "../components/TransferOptionsMobile";
// // // // // import MobileTransferSearch from "../components/MobileTransferSearch";
// // // // // import VipServices from "../components/VipServices";
// // // // // import { useTranslation } from "react-i18next";
// // // // // import DealCountdown from "../components/DealCountdown";

// // // // // function Dashboard() {
// // // // //   // const { user } = useSelector((state) => state.auth);
// // // // //   // const { logout } = useAuthCalls();
// // // // //   const { t } = useTranslation();

// // // // //   return (
// // // // //     <>
// // // // //       <section className="relative w-full">
// // // // //         {/* === PC Görseli ve Arama Kutusu === */}
// // // // //         <div
// // // // //           className="hidden md:block bg-cover bg-center bg-no-repeat"
// // // // //           style={{
// // // // //             // backgroundImage: "url('/images/pcbanner4.png')",
// // // // //             backgroundImage: "url('/images/womanbanner.png')",
// // // // //             height: "700px",
// // // // //             width: "100%",
// // // // //           }}
// // // // //         >
// // // // //           <div
// // // // //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// // // // //             style={{ marginTop: "80px" }}
// // // // //           >
// // // // //             <h1 className="text-4xl font-bold mb-6">{t("home.title")}</h1>
// // // // //           </div>

// // // // //           <div
// // // // //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// // // // //             style={{ marginTop: "650px" }}
// // // // //           >
// // // // //             <SearchBox />
// // // // //           </div>
// // // // //         </div>

// // // // //         {/* === Mobil: Banner üstte tam görünür, sonra DealCountdown ve not === */}
// // // // //         <div className="block md:hidden">
// // // // //           {/* Banner */}
// // // // //           <div className="relative">
// // // // //             <img
// // // // //               src="/images/mobile7.png"
// // // // //               alt="Mobil VIP Transfer"
// // // // //               className="w-full h-[680px] object-cover"
// // // // //               style={{ marginTop: "-80px" }}
// // // // //             />

// // // // //             {/* İstersen başlık bant olarak resmin üstünde kalsın */}
// // // // //             <div className="absolute inset-x-0 top-6 flex justify-center">
// // // // //               <span className="bg-black/70 text-white font-extrabold px-4 py-2 rounded-lg tracking-wide">
// // // // //                 {t("home.title")}
// // // // //               </span>
// // // // //             </div>
// // // // //           </div>

// // // // //           {/* Bannerın ALTINDA tam genişlik DealCountdown */}
// // // // //           <div className="bg-black">
// // // // //             <div className="w-screen -mx-4">
// // // // //               <div className="max-w-md mx-auto px-4 py-2 mt-0">
// // // // //                 {/* DealCountdown'u kart yerine şerit gibi göstermek istiyorsan
// // // // //                    DealCountdown içinde max-w/rounded sınıfları yok olmalı */}
// // // // //                 <DealCountdown />
// // // // //               </div>
// // // // //             </div>

// // // // //             {/* Not – kırmızı & BÜYÜK HARF */}
// // // // //             <p className="text-[14px] md:text-[16px] font-semibold text-red-500 mt-0 text-center uppercase tracking-wide">
// // // // //               {t("home.note")}
// // // // //             </p>
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* Mobil transfer formu ve diğerleri — sırayla aşağıda */}
// // // // //       <MobileTransferSearch />
// // // // //       <TransferOptionsMobile />
// // // // //       <div className="hidden md:block">
// // // // //         <Section1 />
// // // // //       </div>
// // // // //       <VipServices />
// // // // //       <Testimonials />
// // // // //       <BlogPosts />
// // // // //       <Stats />
// // // // //       <Footer />
// // // // //     </>
// // // // //   );
// // // // // }

// // // // // export default Dashboard;
// // // // // import { useSelector } from "react-redux";
// // // // // import useAuthCalls from "../service/useAuthCalls";
// // // // import * as React from "react";
// // // // import Section1 from "../components/Section1";
// // // // import Footer from "../components/Footer";
// // // // import Testimonials from "../components/Testimonials";
// // // // import Stats from "../components/Stats";
// // // // import SearchBox from "../components/SearchBox";
// // // // import BlogPosts from "../components/BlogPosts";
// // // // import TransferOptionsMobile from "../components/TransferOptionsMobile";
// // // // import MobileTransferSearch from "../components/MobileTransferSearch";
// // // // import VipServices from "../components/VipServices";
// // // // import { useTranslation } from "react-i18next";
// // // // import DealCountdown from "../components/DealCountdown";

// // // // function Dashboard() {
// // // //   // const { user } = useSelector((state) => state.auth);
// // // //   // const { logout } = useAuthCalls();
// // // //   const { t } = useTranslation();

// // // //   return (
// // // //     <>
// // // //       <section className="relative w-full">
// // // //         {/* === PC Görseli ve Arama Kutusu === */}
// // // //         <div
// // // //           className="hidden md:block bg-cover bg-center bg-no-repeat"
// // // //           style={{
// // // //             // backgroundImage: "url('/images/pcbanner4.png')",
// // // //             backgroundImage: "url('/images/womanbanner.png')",
// // // //             height: "700px",
// // // //             width: "100%",
// // // //           }}
// // // //         >
// // // //           <div
// // // //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// // // //             style={{ marginTop: "80px" }}
// // // //           >
// // // //             <h1 className="text-4xl font-bold mb-6">{t("home.title")}</h1>
// // // //           </div>

// // // //           <div
// // // //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// // // //             style={{ marginTop: "650px" }}
// // // //           >
// // // //             <SearchBox />
// // // //           </div>
// // // //         </div>

// // // //         {/* === Mobil: Banner üstte tam görünür, sonra DealCountdown ve not === */}
// // // //         <div className="block md:hidden">
// // // //           {/* Banner */}
// // // //           <div className="relative">
// // // //             <img
// // // //               src="/images/mobile12.png"
// // // //               alt="Mobil VIP Transfer"
// // // //               className="block w-full h-[680px] object-cover"
// // // //               style={{ marginTop: "-80px" }}
// // // //             />
// // // //             {/* Başlık bant */}
// // // //             <div className="absolute inset-x-0 top-6 flex justify-center">
// // // //               <span className="bg-black/70 text-white font-extrabold px-4 py-2 rounded-lg tracking-wide">
// // // //                 {t("home.title")}
// // // //               </span>
// // // //             </div>
// // // //           </div>

// // // //           {/* Bannerın ALTINDA tam genişlik DealCountdown */}
// // // //          <div className="bg-black overflow-hidden">
// // // //   <div className="w-screen -mx-4 bg-black">
// // // //     {/* ⬇️ alt paddingi küçülttük (pb-2) -> metinlere yer açıldı */}
// // // //     <div className="max-w-md mx-auto px-4 pt-5 pb-2">
// // // //       <DealCountdown />
// // // //     </div>
// // // //   </div>

// // // //   {/* ⬇️ metin grubunu biraz YUKARI çek ( -mt-3 ) */}
// // // //   <div className="max-w-md mx-auto px-4 -mt-3 pb-3">
// // // //     <p className="text-[14px] md:text-[16px] font-semibold text-red-500 text-center uppercase tracking-wide leading-tight">
// // // //       {t("home.note")}
// // // //     </p>
// // // //     <p className="text-[13px] md:text-[15px] font-semibold text-yellow-500 text-center leading-tight mt-1">
// // // //       Payment is made after the journey is completed.
// // // //     </p>
// // // //   </div>
// // // // </div>
// // // //         </div>
// // // //       </section>

// // // //       {/* Mobil transfer formu ve diğerleri — sırayla aşağıda */}
// // // //       <MobileTransferSearch />
// // // //       <TransferOptionsMobile />
// // // //       <div className="hidden md:block">
// // // //         <Section1 />
// // // //       </div>
// // // //       <VipServices />
// // // //       <Testimonials />
// // // //       <BlogPosts />
// // // //       <Stats />
// // // //       <Footer />
// // // //     </>
// // // //   );
// // // // }

// // // // export default Dashboard;
// // // import * as React from "react";
// // // import Section1 from "../components/Section1";
// // // import Footer from "../components/Footer";
// // // import Testimonials from "../components/Testimonials";
// // // import Stats from "../components/Stats";
// // // import SearchBox from "../components/SearchBox";
// // // import BlogPosts from "../components/BlogPosts";
// // // import TransferOptionsMobile from "../components/TransferOptionsMobile";
// // // import MobileTransferSearch from "../components/MobileTransferSearch";
// // // import VipServices from "../components/VipServices";
// // // import { useTranslation } from "react-i18next";
// // // import DealCountdown from "../components/DealCountdown";

// // // function Dashboard() {
// // //   const { t } = useTranslation();

// // //   return (
// // //     <>
// // //       {/* DESKTOP */}
// // //       <section className="relative w-full">
// // //         <div
// // //           className="hidden md:block bg-cover bg-center bg-no-repeat"
// // //           style={{
// // //             backgroundImage: "url('/images/womanbanner.png')",
// // //             height: "700px",
// // //             width: "100%",
// // //           }}
// // //         >
// // //           <div
// // //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// // //             style={{ marginTop: "80px" }}
// // //           >
// // //             <h1 className="text-4xl font-bold mb-6">{t("home.title")}</h1>
// // //           </div>
// // //           <div
// // //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// // //             style={{ marginTop: "650px" }}
// // //           >
// // //             <SearchBox />
// // //           </div>
// // //         </div>

// // //         {/* === MOBILE (üst üste, overlap YOK) === */}
// // //         <div className="md:hidden min-h-[100dvh] flex flex-col">
// // //           {/* 1) Görsel (üstüne hiçbir şey gelmiyor) */}
// // //           <img
// // //             src="/images/mobile12.png"
// // //             alt="Mobil VIP Transfer"
// // //             className="w-full h-[34dvh] object-cover"
// // //             /* gerekiyorsa biraz daha kıs: h-[32dvh] */
// // //           />

// // //           {/* 2) İçerik bloğu */}
// // //           <div className="flex-1 flex flex-col gap-2 px-3 py-2 bg-black">
// // //             {/* Başlık */}
// // //             <h1 className="text-white text-[clamp(14px,2.8vw,18px)] font-extrabold text-center">
// // //               {t("home.title")}
// // //             </h1>

// // //             {/* Sayaç (kompakt) */}
// // //             <div className="shrink-0">
// // //               <div className="scale-[0.9] origin-top">
// // //                 <DealCountdown />
// // //               </div>
// // //             </div>

// // //             {/* Notlar (kompakt tipografi) */}
// // //             <div className="space-y-1">
// // //               <p className="text-[12px] font-semibold text-red-500 text-center uppercase tracking-wide leading-tight">
// // //                 {t("home.note")}
// // //               </p>
// // //               <p className="text-[12px] font-semibold text-yellow-500 text-center leading-tight">
// // //                 Payment is made after the journey is completed.
// // //               </p>
// // //             </div>

// // //             {/* Form (kompakt) */}
// // //             <div className="mt-auto compact-forms">
// // //               <MobileTransferSearch />
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Mobile'da form yukarıda; desktop için altta tekrar gösterebiliriz */}
// // //       <div className="hidden md:block">
// // //         <MobileTransferSearch />
// // //       </div>

// // //       <TransferOptionsMobile />
// // //       <div className="hidden md:block">
// // //         <Section1 />
// // //       </div>
// // //       <VipServices />
// // //       <Testimonials />
// // //       <BlogPosts />
// // //       <Stats />
// // //       <Footer />

// // //       {/* === KOMPAKT FORM OVERRIDE ===
// // //           MobileTransferSearch içindeki input/select/button'ları inceltir.
// // //           İstersen bu stilleri global css'e taşıyabilirsin. */}
// // //       <style>{`
// // //         @media (max-width: 767px) {
// // //           .compact-forms input,
// // //           .compact-forms select,
// // //           .compact-forms button,
// // //           .compact-forms textarea {
// // //             height: 38px !important;
// // //             padding: 6px 10px !important;
// // //             font-size: 13px !important;
// // //             line-height: 1.1 !important;
// // //             border-radius: 8px !important;
// // //           }
// // //           .compact-forms .form-row,
// // //           .compact-forms .grid,
// // //           .compact-forms .flex {
// // //             gap: 6px !important;
// // //           }
// // //           .compact-forms .btn,
// // //           .compact-forms [type="submit"] {
// // //             height: 40px !important;
// // //             padding: 8px 12px !important;
// // //             font-weight: 600 !important;
// // //           }
// // //           /* DealCountdown çok yer kaplıyorsa:
// // //              .compact-forms { margin-top: 4px !important; } */
// // //         }
// // //       `}</style>
// // //     </>
// // //   );
// // // }

// // // export default Dashboard;
// // import * as React from "react";
// // import Section1 from "../components/Section1";
// // import Footer from "../components/Footer";
// // import Testimonials from "../components/Testimonials";
// // import Stats from "../components/Stats";
// // import SearchBox from "../components/SearchBox";
// // import BlogPosts from "../components/BlogPosts";
// // import TransferOptionsMobile from "../components/TransferOptionsMobile";
// // import MobileTransferSearch from "../components/MobileTransferSearch";
// // import VipServices from "../components/VipServices";
// // import { useTranslation } from "react-i18next";
// // import DealCountdown from "../components/DealCountdown";

// // function Dashboard() {
// //   const { t } = useTranslation();

// //   return (
// //     <>
// //       {/* DESKTOP */}
// //       <section className="relative w-full">
// //         <div
// //           className="hidden md:block bg-cover bg-center bg-no-repeat "
// //           style={{
// //             backgroundImage: "url('/images/womanbanner.png')",
// //             height: "700px",
// //             width: "100%",
// //           }}
// //         >
// //           <div
// //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// //             style={{ marginTop: "80px" }}
// //           >
// //             <h1 className="text-4xl font-bold mb-6">{t("home.title")}</h1>
// //           </div>
// //           <div
// //             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
// //             style={{ marginTop: "650px" }}
// //           >
// //             <SearchBox />
// //           </div>
// //         </div>

// //         {/* === MOBILE (sıkı tasarım) === */}
// //         <div className="md:hidden min-h-[100dvh] flex flex-col">
// //           {/* Görsel */}
// //           {/* <img
// //             src="/images/mobile13.jpg"
// //             alt="Mobil VIP Transfer"
// //             className="w-full h-[28dvh] object-cover"
// //           /> */}
// //           <img
// //   src="/images/mobile13.jpg"
// //   alt="Mobil VIP Transfer"
// //   className="w-full h-[28dvh] object-cover object-[50%_15%]"
// // />

// //           {/* İçerik */}
// //           <div className="flex-1 flex flex-col px-3 py-1 bg-black tight-stack">
// //             {/* Başlık */}
// //             <h1 className="text-white text-[13px] font-extrabold text-center leading-none">
// //               {t("home.title")}
// //             </h1>

// //             {/* Sayaç */}
// //             <div className="squish -mt-1 -mb-1">
// //               <div className="scale-[0.82] origin-top">
// //                 <DealCountdown />
// //               </div>
// //             </div>

// //             {/* Notlar */}
// //             <div className="squish -mt-1 -mb-1">
// //               <p className="text-[11px] font-semibold text-red-500 text-center uppercase tracking-wide leading-[1.05]">
// //                 {t("home.note")}
// //               </p>
// //               <p className="text-[11px] font-semibold text-yellow-500 text-center leading-[1.05]">
// //                 Payment is made after the journey is completed.
// //               </p>
// //             </div>

// //             {/* Form */}
// //             <div className="mt-auto compact-forms squish">
// //               <MobileTransferSearch />
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Mobile'da form yukarıda göründü; desktop için tekrar */}
// //       <div className="hidden md:block">
// //         <MobileTransferSearch />
// //       </div>

// //       <TransferOptionsMobile />
// //       <div className="hidden md:block">
// //         <Section1 />
// //       </div>
// //       <VipServices />
// //       <Testimonials />
// //       <BlogPosts />
// //       <Stats />
// //       <Footer />

// //       {/* === Sıkılaştırma CSS === */}
// //       <style>{`
// //         @media (max-width: 767px) {
// //           .tight-stack > * { margin-top: 0 !important; margin-bottom: 0 !important; }
// //           .tight-stack { gap: 2px !important; }

// //           .squish, .squish * {
// //             margin: 0 !important;
// //             padding-top: 0 !important;
// //             padding-bottom: 0 !important;
// //             line-height: 1.05 !important;
// //           }

// //           .squish [class*="p-"], .squish [class*="py-"], .squish [class*="pt-"], .squish [class*="pb-"] {
// //             padding: 0 !important;
// //           }
// //           .squish [class*="m-"], .squish [class*="my-"], .squish [class*="mt-"], .squish [class*="mb-"] {
// //             margin: 0 !important;
// //           }

// //           .compact-forms input,
// //           .compact-forms select,
// //           .compact-forms button,
// //           .compact-forms textarea {
// //             height: 34px !important;
// //             padding: 4px 8px !important;
// //             font-size: 12px !important;
// //             line-height: 1.05 !important;
// //             border-radius: 8px !important;
// //           }
// //           .compact-forms .form-row,
// //           .compact-forms .grid,
// //           .compact-forms .flex {
// //             gap: 4px !important;
// //           }
// //           .compact-forms [type="submit"],
// //           .compact-forms .btn {
// //             height: 36px !important;
// //             padding: 6px 10px !important;
// //             font-weight: 600 !important;
// //           }
// //         }
// //       `}</style>
// //     </>
// //   );
// // }

// // export default Dashboard;
// import * as React from "react";
// import Section1 from "../components/Section1";
// import Footer from "../components/Footer";
// import Testimonials from "../components/Testimonials";
// import Stats from "../components/Stats";
// import SearchBox from "../components/SearchBox";
// import BlogPosts from "../components/BlogPosts";
// import TransferOptionsMobile from "../components/TransferOptionsMobile";
// import MobileTransferSearch from "../components/MobileTransferSearch";
// import VipServices from "../components/VipServices";
// import { useTranslation } from "react-i18next";
// import DealCountdown from "../components/DealCountdown";

// function Dashboard() {
//   const { t } = useTranslation();

//   return (
//     <>
//       {/* DESKTOP */}
//       <section className="relative w-full">
//         <div
//           className="hidden md:block bg-cover bg-center bg-no-repeat "
//           style={{
//             backgroundImage: "url('/images/womanbanner.png')",
//             height: "700px",
//             width: "100%",
//           }}
//         >
//           <div
//             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
//             style={{ marginTop: "80px" }}
//           >
//             <h1 className="text-4xl font-bold mb-6">{t("home.title")}</h1>
//           </div>
//           <div
//             className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
//             style={{ marginTop: "650px" }}
//           >
//             <SearchBox />
//           </div>
//         </div>

//         {/* === MOBILE === */}
//         {/* ▼▼▼ BÖLÜMÜ AŞAĞI KAYDIRMAK İÇİN mt-6 EKLENDİ ▼▼▼ */}
//         <div className="md:hidden min-h-[100dvh] flex flex-col mt-0">
//           {/* Görsel */}
//           <img
//             src="/images/mobile13.jpg"
//             alt="Mobil VIP Transfer"
//             className="w-full h-[28dvh] object-cover object-[50%_15%]"
//           />

//           {/* İçerik */}
//           <div className="flex-1 flex flex-col px-3 py-2 bg-black tight-stack">
//             {/* Başlık */}
//             <h1 className="text-white text-[13px] font-extrabold text-center leading-none">
//               {t("home.title")}
//             </h1>

//             {/* Sayaç */}
//             <div className="squish -mt-1 -mb-1">
//               <div className="scale-[0.82] origin-top">
//                 <DealCountdown />
//               </div>
//             </div>

//             {/* Notlar */}
//             <div className="squish -mt-1 -mb-1">
//               <p className="text-[11px] font-semibold text-red-500 text-center uppercase tracking-wide leading-[1.05]">
//                 {t("home.note")}
//               </p>
//               <p className="text-[11px] font-semibold text-yellow-500 text-center leading-[1.05]">
//                 Payment is made after the journey is completed.
//               </p>
//             </div>

//             {/* Form */}
//             {/* ▼▼▼ ARALIKLARI SIFIRLAYAN squish KALDIRILDI + formun üstüne boşluk eklendi ▼▼▼ */}
//             <div className="mt-3 compact-forms">
//               <MobileTransferSearch />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Desktop için form tekrar */}
//       <div className="hidden md:block">
//         <MobileTransferSearch />
//       </div>

//       <TransferOptionsMobile />
//       <div className="hidden md:block">
//         <Section1 />
//       </div>
//       <VipServices />
//       <Testimonials />
//       <BlogPosts />
//       <Stats />
//       <Footer />

//       {/* === Stil düzenlemeleri === */}
//       <style>{`
//         @media (max-width: 767px) {
//           .tight-stack > * { margin-top: 0 !important; margin-bottom: 0 !important; }
//           .tight-stack { gap: 2px !important; }

//           /* squish genel sıkılaştırma, ANCAK formu ezmesin diye .compact-forms için istisna ekliyoruz */
//           .squish, .squish * {
//             margin: 0 !important;
//             padding-top: 0 !important;
//             padding-bottom: 0 !important;
//             line-height: 1.05 !important;
//           }

//           /* ▼▼▼ FORM ARALIKLARINI AÇ: sadece compact-forms içinde üst üste gelen kardeşlere boşluk ver ▼▼▼ */
//           .compact-forms > * + * {
//             margin-top: 12px !important; /* input blokları arası */
//           }

//           /* Form kontrollerini kompakt tut */
//           .compact-forms input,
//           .compact-forms select,
//           .compact-forms button,
//           .compact-forms textarea {
//             height: 34px !important;
//             padding: 4px 8px !important;
//             font-size: 12px !important;
//             line-height: 1.15 !important;
//             border-radius: 8px !important;
//           }

//           /* Ara sıra grid/flex içi gap'i minimumda tutuyoruz; artık margin ile aralık veriyoruz */
//           .compact-forms .form-row,
//           .compact-forms .grid,
//           .compact-forms .flex {
//             gap: 4px !important;
//           }

//           .compact-forms [type="submit"],
//           .compact-forms .btn {
//             height: 36px !important;
//             padding: 6px 10px !important;
//             font-weight: 600 !important;
//           }
//         }
//       `}</style>
//     </>
//   );
// }

// export default Dashboard;
import * as React from "react";
import Section1 from "../components/Section1";
import Footer from "../components/Footer";
import Testimonials from "../components/Testimonials";
import Stats from "../components/Stats";
import SearchBox from "../components/SearchBox";
import BlogPosts from "../components/BlogPosts";
import TransferOptionsMobile from "../components/TransferOptionsMobile";
import MobileTransferSearch from "../components/MobileTransferSearch";
import VipServices from "../components/VipServices";
import { useTranslation } from "react-i18next";
import DealCountdown from "../components/DealCountdown";

function Dashboard() {
  const { t } = useTranslation();

  return (
    <>
      {/* DESKTOP */}
      <section className="relative w-full">
        <div
          className="hidden md:block bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/images/womanbanner.png')",
            height: "700px",
            width: "100%",
          }}
        >
          <div
            className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
            style={{ marginTop: "80px" }}
          >
            <h1 className="text-4xl font-bold mb-6">{t("home.title")}</h1>
          </div>
          <div
            className="absolute inset-0 bg-black/10 flex flex-col items-center text-white text-center px-4"
            style={{ marginTop: "650px" }}
          >
            <SearchBox />
          </div>
        </div>

        {/* === MOBILE === */}
        <div className="md:hidden bg-black ">
          {/* Görsel – daha kısa */}
          {/* <img
            src="/images/mobile14.jpg"
            alt="Mobil VIP Transfer"
            className="w-full h-[22dvh] object-cover object-[50%_15%]"
          /> */}
          <img
  src="/images/mobile15.png"
  alt="Mobil VIP Transfer"
  className="w-full h-[36dvh] object-cover object-[50%_15%]"
/>


          <div className="px-3 pt-1 pb-2">
            {/* Başlık küçük */}
            {/* <h1 className="text-white text-[12px] font-extrabold text-center leading-tight">
              {t("home.title")}
            </h1> */}

            {/* Sayaç – kompakt */}
            <div className="mt-1">
              <DealCountdown />
            </div>

            {/* Notlar – tek satır yüksekliğinde */}
            <div className="mt-1 space-y-0.5">
              <p className="text-[10px] font-semibold text-red-500 text-center uppercase leading-[1.15] -mb-1">
                {t("home.note")}
              </p>
            <p className="text-[10px] font-semibold text-yellow-500 text-center leading-tight -mt-1">
   {t("home.description")}
</p>

            </div>

            {/* Quick Reservation – hemen altında, kompakt sürüm */}
            <div className="mt-1">
              <MobileTransferSearch />
            </div>
          </div>
        </div>
      </section>

      {/* Masaüstü için form tekrar */}
      <div className="hidden md:block">
        <MobileTransferSearch />
      </div>

      <TransferOptionsMobile />
      <div className="hidden md:block">
        <Section1 />
      </div>
      <VipServices />
      <Testimonials />
      <BlogPosts />
      <Stats />
      <Footer />
    </>
  );
}

export default Dashboard;
